import React from 'react';

import styles from 'styles/components/gigs/GigDetails.module.scss';

const borderTop = { borderTop: '1px solid rgba(0, 0, 0, 0.15)' };

const TypeAndFrequency = ({ gig, hasBorderTop = false }) => {
  if (gig.type_and_frequency.length === 0) return null;

  return (
    <div className={styles.padding} style={hasBorderTop ? borderTop : {}}>
      <h3>Type & frequency</h3>

      {gig.type_and_frequency.map((type, index) => (
        <div key={index}>
          <span>{type.includes('Gains') ? type.replace('1 ', '') : type}</span>
          <br />
        </div>
      ))}
    </div>
  );
};
export default TypeAndFrequency;
